module.exports = __webpack_public_path__ + "img/X-CARE-Plus-PremiumWarranty-Logo_1000x1000.05a43f99.png";